// extracted by mini-css-extract-plugin
export default {"container":"trusted-us_container__sasKf","header":"trusted-us_header__l+hhV","logos":"trusted-us_logos__Ux6pu","row":"trusted-us_row__S-XDB","logo":"trusted-us_logo__RU+le"};